import React from "react";
import * as dc from "dc";
import * as d3 from "d3";
import reductio from "reductio";
import { ChartTemplate } from "./chartTemplate";
import { count } from "d3";

/* 
dc-js chart template 
 */
const anualPrepChartFunc = (divRef, ndx) => {
  // dimension by  county
  const dimension = ndx.dimension((d) => d.baseTbCode);
  // compute or return the anuall rianfall  for every  county
  var grp = dimension.group().reduceSum(function (d) {
    return d.annual_Precipitation;
  });
    // custom reducer to  compute the averages
    const anualPrepgroup = dimension.groupAll().reduce(
    /* callback for when data is added to the current filter results */
    function (p, v) {
          ++p.count;
          p.tot += v.annual_Precipitation;
          p.avg = p.tot / 47
          p.actual = v.annual_Precipitation
      return p;
        },
    /* callback for when data is removed from the current filter results */
    function (p, v) {
        --p.count;
        p.tot -= v.annual_Precipitation;
        p.avg = p.count ? p.tot / 47 : 0; // hard code number of counties due to dublicates in data
        p.actual = v.annual_Precipitation
      return p;
        },
    /* initialize p */
    function () {
        return { count: 0, tot: 0 ,avg:0,actual:0};
    }
  );
    const all = ndx.groupAll().reduceSum((d) => d.annual_Precipitation).value();
    let total_anual_prep = all
   
  //  create the dc instance
    const projects = dc.numberDisplay(divRef);
      // set the chart parameters
    projects

        .dimension(dimension)

        .formatNumber(d3.format(",.2f"))

        .group(anualPrepgroup)

        .transitionDuration(0)

        // calculate values depending on the value being returned by the filter
        .on("pretransition  ", function (chart) {
            chart.valueAccessor((d) => {
            //console.log("totals :" + total_anual_prep)
                let a = d.avg * 47
            //console.log("a " + a )
                let b = total_anual_prep
                let record_count = d.count/24 // the counties rows are dublicated 24 time 
            //console.log("b " + b)
                if (a < b && record_count == 1) {
                    //console.log("First if statement: " + a)
                    return a
                } else if (a < b && record_count > 1) {
                    return a / record_count
                } else if (a == b) {
                    
                    return a / 47
                
                }
            });

        })

        .valueAccessor((d) => {
            return d.avg; // return the average rainfall for all the counties.
        })



  // return the dc chart  object
    return projects;

};

export const AnnualPrecipitationChart = (props) => (
  // pass the chart object to the Chart template for rendering
  <ChartTemplate chartFunction={anualPrepChartFunc} />
);
